import { useState, useEffect } from 'react';
import QuestionContents from './UI/QuestionContents';
const Choice = (props) => {
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [questionId, setQuestionId] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const onClick = () => {
        window.location.href = "/admin/editquestiondetails/" + questionId + "/choice";

    }

    useEffect(() => {
        setQuestion(JSON.parse(props.data.contentStr))
        setAnswers(JSON.parse(props.data.detail));
        setQuestionId(JSON.parse(props.data.id));
        let que = JSON.parse(props.data.contentStr)

        var questionTitlee = que['text'].split('__')[0];
        let questionTextt = que['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
    }, []);

    return (
        <div>
            <hr />
            <div style={{ alignItems: "center", textAlign: "center" }}>
                <b>Choice Sorusu</b>
                <QuestionContents question={question} />
                <h4>                    {questionTitle}
                </h4>

                <h6>
                    {questionText}
                </h6>
                <hr />
            </div>
            <div class="d-flex justify-content-center" style={{ fontSize: 20, textAlign: "center" }}>
                <div className="row">
                    {answers && answers.map((dt) => {
                        return (
                            <div class="col" >
                                <input type="radio" style={{ height: "20px" }} id={dt.id} name="answerRate" value={dt.id} />
                                {dt['service']}
                                {dt['photo'] ? (
                                    <img style={{ width: "200px", height: "50%" }} src={dt['photo']} />
                                ) : (
                                    <div></div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='d-flex justify-content-center'>
                <button className='btn btn-info' onClick={onClick}>Soruyu Düzenle</button>
            </div>
        </div>
    );
};

export default Choice;